// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{overflow:hidden}#app{margin:0 auto;font-family:PingFang SC,Microsoft YaHei,Helvetica Neue,Arial,Hiragino Sans GB,微软雅黑,SimSun,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#333;height:100%;display:flex;flex-direction:column}.el-scrollbar>.el-scrollbar__bar{opacity:1!important}.flex{display:flex}.flex-between{justify-content:space-between}", ""]);
// Exports
module.exports = exports;
